import React, { Component } from 'react';
import Line from '../charts/line.js';
import Spine from '../charts/spine.js';
import ChartMatrix from '../charts/matrix.js';
import './leaders.css';
import Texts from '../data/leaders.json';
 
class Leaders extends Component {
	constructor(props) {
    super(props);

    this.getBoundaries = this.getBoundaries.bind( this );
    this.toggleSerie = this.toggleSerie.bind( this );

    this.state = {
      activeSeries: [ 'serie-0', 'serie-1' ],
      xBoundaries: [ new Date('2018-02-01').getTime() , new Date('2018-06-06').getTime() ],
      yBoundaries: this.getBoundaries()
    }
	}
	
	componentDidMount() {
  }

  componentDidUpdate( prevProps, prevState ) {}

  getBoundaries() {
    let quantities = [];
    Texts.leaders.forEach(
      ( leader ) => {
        let serie = this.props.Data.data.keywords[leader.id];
        serie.forEach(
          (point) => {
            quantities.push( parseInt(point.number, 10) );
        });
      }
    );
    return [ Math.min( 0, Math.min(...quantities) ), Math.max(...quantities) ];
  }

  toggleSerie( serie ) {
    const needle = 'serie-' + serie;
    let activeSeries = this.state.activeSeries.slice(0);
    const index = activeSeries.indexOf(needle);
    if ( index === -1 ) {
      activeSeries.push( needle );
    } else {
      activeSeries.splice( index, 1 );
    }
    this.setState( { activeSeries } );
  }

	render() {
    return (
      <div className="leaders in">
        <div className="leaders--legend">
          <div className="leaders--legend--item item" >
            <div className="item--text">
              <div className="item--text--title">
                <h1>I Leader</h1>
              </div>
              <div className="item--text--body">
                <div>
                  <p>Questa campagna elettorale è stata molto personalizzata, quasi all'americana. Ogni schieramento si è presentato alle elezioni con un leader dichiarato, che ha assunto il ruolo di guida e voce della sua coalizione.</p>
                  <p>Questo è stato indubbiamente vero per tutti gli schieramenti tranne che per il Centro Destra, dove sia <a href="/#/filtra/berlusconi">Silvio Berlusconi</a> che <a href="/#/filtra/salvini">Matteo Salvini</a> hanno reclamato più volte il ruolo di guida, e dove alcune spaccature avevano iniziato a vedersi già ad inizio febbraio, in occasione della <a href="/#/filtra/anti+inciucio">manifestazione anti-inciucio</a> promossa da <a href="/#/filtra/meloni">Giorgia Meloni</a>. Come sia andata a finire è sotto agli occhi di tutti: Salvini al governo alleato con il <a href="/#/categoria/m5s">Movimento 5 Stelle</a> guidato da <a href="/#/filtra/di+maio">Luigi Di Maio</a>, e Silvio Berlusconi praticamente scomparso dalla scena politica.</p>
                  <p>Proviamo quindi a vedere come si è evoluta la copertura stampa dedicata ai vari leader di partito nel periodo monitorato.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="leaders--data">
          {
            Texts.leaders.map(
              (item, index) => {
                return (
                  <article key={item.id + index} className="item">
                    <div className="item--text--title">
                      <h3>{item.title}</h3>
                      <h4>{item.body}</h4>
                    </div>
                    <div className="item--chart">
                      <Line series={[ this.props.Data.data.keywords[item.id] ]} xBoundaries={this.state.xBoundaries} yBoundaries={this.state.yBoundaries} />
                    </div>
                  </article>
                )
              }
            )
          }
        </div>
        <div className="leaders--legend">
          <div className="leaders--legend--item item" >
            <div className="item--text">
              <div className="item--text--title">
                <h2>Le relazioni</h2>
              </div>
              <div className="item--text--body">
                <div>
                  <p>Quanti punti di contatto hanno avuto i leader dei diversi partiti durante la campagna elettorale? E dopo il voto? Queste matrici mostrano il volume di articoli pubblicati dalla stampa che citano assieme due politici (i leader dei diversi schieramenti, più il Presidente della Repubblica Sergio Mattarella), e ci consentono di capire come gli equilibri, anche sui giornali, siano cambiati in pochi mesi.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="leaders--data matrix">
          <div className="item">
            <div className="item--text--title">
              <h3>Prima delle elezioni</h3>
            </div>
            <div className="item--chart">
              <div className="in">
                <ChartMatrix Matrix={this.props.Data.data.matrix.pre.matrix} Axis={this.props.Data.data.matrix.pre.keywords} ChartId={'id'} Min={0} Max={this.props.Data.data.matrix.pre.max} />
              </div>
            </div>
          </div>
          <div className="item">
          <div className="item--text--title">
              <h3>Dopo le elezioni</h3>
            </div>
            <div className="item--chart">
              <div className="in">
                <ChartMatrix Matrix={this.props.Data.data.matrix.post.matrix} Axis={this.props.Data.data.matrix.post.keywords} ChartId={'id'} Min={0} Max={this.props.Data.data.matrix.post.max} />
              </div>
            </div>
          </div>
        </div>
        <div className="leaders--legend">
          <div className="leaders--legend--item item" >
            <div className="item--text">
              <div className="item--text--title">
                <h2>Le coppie</h2>
              </div>
              <div className="item--text--body">
                <div>
                  <p>Come in ogni vera commedia all'italiana, a tenere in piedi la storia sono le coppie, e i tradimenti, che in politica talvolta prendono il nome di "<em>responsabilità</em>", altre volte di "<em>inciucio</em>". Queste elezioni non si sono differenziate e, come nella migliore tradizione, ci hanno offerto un <em>inciucio</em>: <strong>Matteo Salvini</strong>, ben sessanta giorni dopo la fine dello spoglio dei voti, cede alle lusinghe di <strong>Luigi Di Maio</strong> e lascia il suo alleato <strong>Silvio Berlusconi</strong> per entrare nel governo <em>gialloverde</em>.</p>
                  <h3>Ma come hanno reagito i giornali?</h3>
                  <p>In questo grafico potete vedere come è cambiata l'attività che riguarda i tre protagonisti di questa vicenda presi singolarmente (Salvini in verde, Di Maio in giallo, Berlusconi in blu) e tenendo conto solo degli articoli che parlano contemporaneamente di due dei protagonisti: Salvini e Di Maio (tratteggiata gialla), e Salvini e Berlusconi (tratteggiata blu).</p>
                  <p>Clicca sui nomi nella legenda per evidenziare le singole linee.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="leaders--data couples">
          <div className="item">
            <div className={"item--chart " + this.state.activeSeries.join(' ') }>
              <Line series={[ this.props.Data.data.keywords.dimaiosalvini, this.props.Data.data.keywords.berlusconisalvini, this.props.Data.data.keywords.berlusconi, this.props.Data.data.keywords.salvini, this.props.Data.data.keywords.dimaio ]} xBoundaries={this.state.xBoundaries} />
              <div className="item--chart--legend">
                <div className="entry dimaio" onClick={ () => { this.toggleSerie('4'); } }>Luigi Di Maio</div>
                <div className="entry dimaiosalvini" onClick={ () => { this.toggleSerie('0'); } }>Di Maio e Salvini</div>
                <div className="entry salvini" onClick={ () => { this.toggleSerie('3'); } }>Matteo Salvini</div>
                <div className="entry berlusconisalvini" onClick={ () => { this.toggleSerie('1'); } }>Berlusconi e Salvini</div>
                <div className="entry berlusconi" onClick={ () => { this.toggleSerie('2'); } }>Silvio Berlusconi</div>
              </div>
            </div>
          </div>
        </div>
        <div className="leaders--legend">
          <div className="leaders--legend--item item" >
            <div className="item--text">
              <div className="item--text--title">
                <h2>I vice</h2>
              </div>
              <div className="item--text--body">
                <div>
                  <p>Sarebbe logico aspettarsi che la coppia uscita vincente da queste elezioni (<strong>Matteo Salvini, Luigi Di Maio</strong>) sia stata quasi una novità per i media, e che gli articoli che parlano di entrambi abbiano iniziato ad aumentare dopo le elezioni. Ma quanto è importante la differenza di attività tra il prima e il dopo elezioni?</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="leaders--data vice">
          <div className="item">
            <div className="item--chart">
              <Spine data={ [ { title: 'Prima', value: parseInt( this.props.Data.data.vice.pre.matrix.salvini['di maio'], 10 ) }, { title: 'Dopo', value: parseInt( this.props.Data.data.vice.post.matrix.salvini['di maio'], 10 ) } ] } description={'Articoli che parlano contemporaneamente di Matteo Salvini e Luigi Di Maio, prima e dopo le elezioni. '} title={'I vice-premier'} />
            </div>
          </div>
        </div>
      </div>
      
    )
	}
}

export default Leaders;


// WEBPACK FOOTER //
// ./src/Elezioni/dataviz/leaders.js